import React from 'react';
import styled from 'styled-components';
import { Spinner as BootstrapSpinner, SpinnerProps } from 'react-bootstrap';

const Spinner = ({ animation, size, ...props }: SpinnerProps): React.ReactElement => (
  <Container>
    <StyledSpinner animation={animation} size={size} {...props} />
  </Container>
);

export { Spinner };

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
`;

const StyledSpinner = styled(BootstrapSpinner)`
  color: #0a4599;
`;
